// extracted by mini-css-extract-plugin
module.exports = {"singleitem":"IngredientsItem_singleitem__19bYu","btn":"IngredientsItem_btn__2RU3i"};